import React from 'react';
import { getGentleReflection } from '../utils/patternSignals';

/**
 * GentleReflection - Ambient awareness from community patterns
 *
 * Shows calm statements about collective behavior:
 * - "Many people noticed this kind of thinking outside the app"
 * - "This capacity has shown up in daily life for other learners"
 * - "Others have paused here too, reflecting on this moment"
 *
 * Design principles:
 * - Never show numbers or metrics
 * - Never competitive or comparative
 * - Subtle, optional to notice
 * - Reinforces that learning extends beyond the app
 * - Strengthens Ubuntu: "You're not alone"
 */
function GentleReflection({ levelId, pillarKey }) {
  const reflection = getGentleReflection(levelId, pillarKey);

  if (!reflection) {
    return null; // Don't show anything if no meaningful patterns yet
  }

  return (
    <div className="mt-4 p-3 bg-slate-900/20 rounded-lg border border-slate-700/20">
      <div className="flex items-start gap-2">
        <span className="text-slate-500 text-sm mt-0.5">✦</span>
        <p className="text-slate-400 text-sm leading-relaxed italic">
          {reflection.text}
        </p>
      </div>
    </div>
  );
}

export default GentleReflection;
